import axios from "axios";

import {
  GET_AccessL,
  RESET_AccessL,
  LOADING
} from "../actionTypes";
import { DEV_APIS_URL } from "configurations";
import { adminTokenDev } from "../../helper";

const { SET_TRUE, SET_FALSE } = LOADING;

export const get = () => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.get(
          `${DEV_APIS_URL}/access-level`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch({ type: GET_AccessL, payload: res.data });
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const add = ({ name = "", desc = "" }) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.post(
          `${DEV_APIS_URL}/access-level`,
          {
            "access_level_name": `${name}`,
            "description": `${desc}`
          },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const update = ({ id = "", name = "", desc = "" }) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.put(
          `${DEV_APIS_URL}/access-level`,
          {
            "id":id,
            "access_level_name": `${name}`,
            "description": `${desc}`
        },
          
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const deletedata = ({ id = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.delete(
        `${DEV_APIS_URL}/access-level/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const reset = () => dispatch => dispatch({ type: RESET_AccessL });
